<template>
  <div v-if="sensor">
    <material-card
      v-bind="{ title: getTitle(), text: getText() }"
      color="dover-blue"
      icon="mdi-account-convert">
      <v-container
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs4
            md3
            lg3>
            <span
              class="dover-blue-color">
              {{ $t('Last measure: {0}', [currentDate]).toUpperCase() }}
            </span>
          </v-flex>
          <v-flex
            xs4
            md3
            lg3
            text-xs-center>
            <span
              class="dover-blue-color">
              {{ $t('Status: {0}', [status]).toUpperCase() }}
            </span>
          </v-flex>
          <v-flex
            xs4
            md3
            lg3
            text-xs-center>
            <v-btn
              v-if="sensor.lastAlarm.ackStatus === 1"
              depressed
              small
              color="primary"
              @click="onAckSensorStatus">
              {{ $t('Ack is required') }}
            </v-btn>
            <span
              v-else
              class="dover-blue-color">
              {{ ackStatus }}
            </span>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <hr>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-if="sensor.sensorType === 0"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-1-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(0), 4), value: decodeReadingChannelValue(0) }"
              :sub-text="`${ $t('Status') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else-if="sensor.sensorType === 1"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-1-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(0), 4), value: decodeReadingChannelValue(0) }"
              :sub-text="`${ $t('Status') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
          <v-flex
            xs6
            md8
            lg8 />
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-2-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(1), 4), value: decodeReadingChannelValue(1) }"
              :sub-text="`${ $t('Status') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else-if="sensor.sensorType === 3"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-1-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(0), 4), value: decodeReadingChannelValue(0) }"
              :sub-text="`${ $t('Level') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else-if="sensor.sensorType === 2"
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-1-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(0), 4), value: decodeReadingChannelValue(0) }"
              :sub-text="`${ $t('Level') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
          <v-flex
            xs6
            md8
            lg8 />
          <v-flex
            xs1
            md1
            lg1 />
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-2-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: Maglink.RoundFormat(getReadingChannelValue(1), 4), value: decodeReadingChannelValue(1) }"
              :sub-text="`${ $t('Water') }`"
              color="dover-blue"
              icon="mdi-water"/>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container
        v-else
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          row
          wrap>
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="transparent"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-img
                :src="getSensorImage()" />
            </v-card>
          </v-flex>
          <v-flex
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-1-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: `${ levelUnit }`, value: getCurrentValue(Maglink.LevelToDisplay(getReadingChannelValue(0), systemSettings.levelUnit)) }"
              :sub-text="`${ $t('Level') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
          <v-flex
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: getReadingChannelStatus(0), value: decodeReadingChannelStatus(0) }"
              :sub-text="`${ $t('Status') }`"
              color="dover-blue"
              icon="mdi-information" />
          </v-flex>
          <v-flex
            xs2
            md6
            lg6 />
          <v-flex
            v-if="sensor.sensorLogicalChannel===2"
            xs1
            md1
            lg1 />
          <v-flex
            v-if="sensor.sensorLogicalChannel===2"
            xs1
            md1
            lg1
            align-center>
            <v-card
              color="dover-blue"
              style="padding: 5px; line-height: 65px; max-width:65px; max-height:65px;"
              dark>
              <v-icon size="56">mdi-numeric-2-box</v-icon>
            </v-card>
          </v-flex>
          <v-flex
            v-if="sensor.sensorLogicalChannel===2"
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: `${ levelUnit }`, value: getCurrentValue(Maglink.LevelToDisplay(getReadingChannelValue(1), systemSettings.levelUnit)) }"
              :sub-text="`${ $t('Level') }`"
              color="dover-blue"
              icon="mdi-elevation-decline"/>
          </v-flex>
          <v-flex
            v-if="sensor.sensorLogicalChannel===2"
            xs4
            md2
            lg2>
            <material-stats-card
              v-bind="{ title: getReadingChannelStatus(1), value: decodeReadingChannelStatus(1) }"
              :sub-text="`${ $t('Status') }`"
              color="dover-blue"
              icon="mdi-information" />
          </v-flex>
        </v-layout>
      </v-container>
    </material-card>
  </div>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  props: {
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    sensor: {
      type: Object,
      required: false,
      default: () => {}
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    sensorTypes: []
  }),
  computed: {
    ackStatus () {
      if (this.sensor.lastAlarm.ackStatus === 0) return this.$t('No alarm').toUpperCase()
      else if (this.sensor.lastAlarm.ackStatus === 1) return this.$t('Alarm is active').toUpperCase()
      else if (this.sensor.lastAlarm.ackStatus === 2) return this.$t('Alarm is acknowledged').toUpperCase()
    },
    currentDate () {
      if (this.systemSettings === undefined) return '--'
      return this.getCurrentValue(this.Maglink.GetCustomDateTime(this.sensor.measuredOn, this.systemSettings.dateFormat))
    },
    levelUnit () {
      return this.options.levelUnits[this.systemSettings.levelUnit || 0].desc
    },
    status () {
      return this.Maglink.GetStatusInfo(this.sensor.sensorStatus).statusDesc
    }
  },
  mounted () {
    this.sensorTypes = this.Maglink.SensorTypesBasic()
    this.sensorTypes = this.sensorTypes.concat(this.Maglink.SensorTypesPlus())
  },
  methods: {
    decodeReadingChannelStatus (channel) {
      let status = this.getReadingChannelStatus(channel)

      if (status === 0) return i18n.t('OK').toUpperCase()

      let result = []

      if ((status & 1) === 1) result.push(i18n.t('DOWN'))
      if ((status & 2) === 2) result.push(i18n.t('SHORT'))
      if ((status & 4) === 4) result.push(i18n.t('OPEN'))
      if ((status & 8) === 8) result.push(i18n.t('WARNING'))
      if ((status & 16) === 16) result.push(i18n.t('ALARM'))

      if (result.length === 0) result.push(i18n.t('UNKNOWN'))

      return result.join(',').toUpperCase()
    },
    decodeReadingChannelValue (channel) {
      let value = this.getReadingChannelValue(channel)

      switch (this.sensor.sensorType) {
        case 0:
        case 1:
          if (value === 0) {
            return i18n.t('Ok').toUpperCase()
          } else {
            return i18n.t('Alarm').toUpperCase()
          }
        case 2:
        case 3:
          if (value >= this.sensor.thresholds[channel].value) {
            return i18n.t('Alarm').toUpperCase()
          } else {
            return i18n.t('Ok').toUpperCase()
          }
        default:
          return value
      }
    },
    getCurrentValue (value) {
      // no link alarm
      if ((this.sensor.sensorStatus & 32) === 32) return '--'

      return value
    },
    getReadingChannelStatus (channel) {
      if (this.sensor === undefined) return 256
      if (this.sensor.readingChannels[channel] === undefined) return 256

      return this.sensor.readingChannels[channel].status
    },
    getReadingChannelThreshold (channel) {
      if (this.sensor === undefined) return 0.0
      if (this.sensor.thresholds[channel] === undefined) return 0.0

      return this.sensor.thresholds[channel].value
    },
    getReadingChannelValue (channel) {
      if (this.sensor === undefined) return 9
      if (this.sensor.readingChannels[channel] === undefined) return 9

      return this.sensor.readingChannels[channel].value
    },
    getSensorImage () {
      return './img/sensor/smart_' + this.sensor.sensorType + '.PNG'
    },
    getText () {
      if (this.sensor === undefined) {
        return ''
      }

      let result = this.sensor.sensorName
      if (result === undefined) {
        result = this.$t('Sensor {0}', [this.sensor.sensorNumber])
      }
      if (this.sensor.sensorType > 1) {
        let formattedNumber = this.sensor.physicalChannels[0].address.toLocaleString('en-US', {
          minimumIntegerDigits: 6,
          useGrouping: false
        })
        result += ' - ' + this.$t('Serial: {0}', [formattedNumber])
      }

      return result
    },
    getTitle () {
      if (this.sensor === undefined) {
        return ''
      }

      let type = this.sensor.sensorType
      if (type === undefined) {
        return this.sensorTypes[0].desc
      }

      let result = ''
      for (let index = 0; index < this.sensorTypes.length; index++) {
        let sensorType = this.sensorTypes[index]

        if (sensorType.code === type) {
          result = sensorType.desc
          break
        }
      }

      return result
    },
    onAckSensorStatus () {
      this.$emit('ackSensorStatus', this.sensor.sensorNumber)
    },
    snack (color, message) {
      message = this.$t('Sensors Status') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
